<template>
	<div>
		<c-app-insights ref="ai" />
		<button
			id="open-dialog-button"
			class="button button--primary sz-4 bg-deep"
			@click="openDialog()"
		>
			<slot name="button-text" />
		</button>
		<slot name="description" />
	</div>
</template>
<script>
	import { refreshSession } from '@cognitoforms/api/services/session';
	import CAppInsights from '@cognitoforms/shared-components/src/components/embeds/AppInsights';

	export default {
		name: 'AuthWithinFrame',
		components: {
			CAppInsights
		},
		props: {
			pageSource: { type: String, default: '' }
		},
		created() {
			this.openDialog();
		},
		methods: {
			openDialog() {
				// Fix for IE returning null for window.origin
				if (!window.origin)
					window.origin = `${window.location.protocol}//${window.location.hostname}` + (`${window.location.port}` ? `:${window.location.port}` : '');

				const paths = [
					window.origin + this.$route.fullPath, // expected path
					(window.origin + this.$route.fullPath).replace(this.pageSource, this.pageSource === 'signup' ? 'login' : 'signup'), // if they switch
					(window.origin + this.$route.fullPath).replace(this.pageSource, 'auth/forgot-password') // forgot password route
				];
				const dialog = window.open(paths[0], `Cognito Forms ${this.pageSource}`, 'width=800,height=800');
				if (!dialog)
					return;

				dialog.onload = () => {
					const isComplete = () => {
						try {
							return !(paths.includes(dialog.location.href));
						}
						catch (e) {
							return false;
						}
					};
					const interval = setInterval(() => {
						if (!dialog || dialog.closed) {
							console.warn('Closed dialog without logging in');
						}
						else if (isComplete()) {
							clearInterval(interval);
							const returnUrl = dialog.location.href;
							dialog.close();
							refreshSession().then(session => {
								if (session.isAuthenticated) {
									window.location.href = returnUrl;
								}
								else if (this.$refs.ai.appInsights)
									this.$refs.ai.appInsights.trackException(new Error('Failed to authenticate within iframe'));
							});
						}
					}, 500);
				};
			}
		}
	};
</script>